// extracted by mini-css-extract-plugin
export default {"w-full":"Tooltip_w-full__l8YuM","tooltip":"Tooltip_tooltip__YRnOd","tooltipWpapper":"Tooltip_tooltipWpapper__BxiTq"};